import { render, staticRenderFns } from "./recoverpwd-2.vue?vue&type=template&id=249271f4&"
import script from "./recoverpwd-2.vue?vue&type=script&lang=js&"
export * from "./recoverpwd-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports